import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import PageTracker from '../../../common/PageTrackerHelper'
import keycloak from '../../../common/Keycloak';

export default {
  name: 'deliveryuserlogout',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect
  },
  props: [],
  mixins:[PageTracker],
  data: function() {
    return {
      listUserData: [],
      currentHub:[],
      userid:'',
      srListLoader: false,
      userDataKey : '',
    }
  },
  computed: {

  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.currentHub.push(userdetail.hubdetails[0]);
    this.getSRUserList();


  },
  methods: {
    customLabel ({ FirstName, LastName, userid, OldDeliveryUserOrUserId, MobileNumber }) {
      return `${FirstName} ${LastName}(${userid}) (${OldDeliveryUserOrUserId}) - ${MobileNumber}`
    },
    //to get hub sr user list to force logout
    getSRUserList() {
      this.srListLoader = true;
      var userToken = window.localStorage.getItem('lmaccessuserdata')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        hubid: this.currentHub
      });
      let apiendpoint = 'external/GetHubSRuserList';
      // if (keycloak.enableKavach) {
      //   apiendpoint = 'user/migration/getforcelogoutuserlist';
      // }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + apiendpoint,
          'data': this.input,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(result => {
           this.listUserData = result.data.data.results;
           this.srListLoader = false;
        }, error => {
          console.error(error)
          this.srListLoader = false;
        })
    },
    forceLogout(event){
      var userToken = window.localStorage.getItem('lmaccessuserdata')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        userid: this.userid.userid,
        modifiedby: this.localuserid
      });
      let apiendpoint = 'external/ForceLogoutUser';
      // if (keycloak.enableKavach) {
      //   apiendpoint = 'user/migration/forcelogoutuser';
      // }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + apiendpoint,
          'data': this.input,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(result => {
          if (result.data.code == 200) {
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.localuserid,
                username:this.useremail,
                meta: {
                    "event":"forceLogoutUser",
                    userid: this.userid.userid
                }
              }
              this.PageTracker(TrackerInfo);
              this.$alertify.success(result.data.message);
          } else {
              this.$alertify.error(result.data.error)
          }
          //event.target.reset();
          this.resetForm();
        }, error => {
          console.error(error)
        })
    },
    resetForm() {
      this.userid = '';
      this.$validator.reset();
      this.errors.clear();
      this.getSRUserList();
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.forceLogout(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/deliveryuserlogout/deliveryuserlogout.component.js